import React from "react";
import { connect } from "react-redux";
import './my-package.scss';
import { getHistoryTransactions, getHistoryUseSessions }
  from 'redux/actions/mvp/session.action';
import { fetchUserMvp } from 'redux/actions/user.action';
import moment from "moment/moment";
import { DatePicker } from "antd";
import { ToastContainer, toast } from "react-toastify";
import upgradePackage from 'static/images/mvp/upgrade-package.png'
import existSession from 'static/images/mvp/exist-sessions.png'
import sessionInPackage from 'static/images/mvp/session-in-package.png'
import expiredDateImage from 'static/images/mvp/expired-date.png'
import startDateImage from 'static/images/mvp/start-date.png'
import { Link } from 'react-router-dom';
import { I18n } from '../../../../helpers/i18n';

class MyPackage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      historyUseSessions: [],
      historyTransactions: [],
    };
  }

  loadPackageData = async () => {
    const { getHistoryUseSessions, getHistoryTransactions } = this.props;
    getHistoryUseSessions().then(rs => {
      this.setState({ historyUseSessions: rs });
    })
    getHistoryTransactions().then(rs => {
      this.setState({ historyTransactions: rs });
      // console.log("historyTransactions", this.state.historyTransactions)
    })
  };

  async componentDidMount() {
    const { fetchUserMvp } = this.props;
    await fetchUserMvp();
    this.loadPackageData();
    // Fetch thêm một lần ngắn sau khi vào trang để bắt kịp dữ liệu vừa mua gói.
    this.refreshTimer = setTimeout(() => {
      this.loadPackageData();
    }, 3000);
    // const promises = [
    //   getHistoryUseSessions(),
    //   getHistoryTransactions()
    // ]
    //
    // const data = await Promise.all(promises);
    // this.setState({ historyUseSessions: data[0] });
    // this.setState({ historyTransactions: data[1] });
  }

  componentWillUnmount() {
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer);
    }
  }

  render() {
    const { header, footer, user } = this.props
    const { historyUseSessions, historyTransactions } = this.state
    let expiredDate = ""
    if (user?.wallet) {
      expiredDate = moment(user?.wallet?.expiredDate).format('D/M/Y')
    }
    let startDate = ""
    if (user?.wallet) {
      startDate = moment(user?.wallet?.startDate).format('D/M/Y')
    }
    console.log('user', user)
    return (
      <div id="site_wrapper">
        {header}
        <main className="main my-package">
          <div className="container">
            <div className="row">
              <div className="title-package col-lg-12 col-md-12 col-sm-12 mb-12">
                <div className="row">
                  <div className="my-package-name col-md-10">
                    <span>{I18n.t('my_package_title')} {user?.wallet?.package}</span>
                  </div>
                  <div className="upgrade-package col-md-2">
                    <Link to="/packages"><img src={upgradePackage} alt="upgradePackage" /></Link>
                    <p>{I18n.t('upgrade_package')}</p>
                  </div>
                </div>
              </div>

              <div className="info-package col-lg-12 col-md-12 col-sm-12 mb-12">
                <p className="title"> {I18n.t('package_information')} </p>
                <div className="info">
                  <div className="row">
                    <div className="exist-sessions col-lg-6 col-md-6 col-sm-6 mb-6">
                      <img src={existSession} alt="upgradePackage" />
                      <div className="detail">
                        <span className="number-or-date">{user?.wallet?.existSession}</span>
                        <span className="description">{I18n.t('remaining_sessions')}</span>
                      </div>
                    </div>
                    <div className="exist-sessions col-lg-6 col-md-6 col-sm-6 mb-6">
                      <img src={sessionInPackage} alt="upgradePackage" />
                      <div className="detail">
                        <span className="number-or-date">{user?.wallet?.sessionInPackage}</span>
                        <span className="description">{I18n.t('number_sessions_in_package')}</span>
                      </div>
                    </div>
                    <div className="exist-sessions col-lg-6 col-md-6 col-sm-6 mb-6">
                      <img src={expiredDateImage} alt="upgradePackage" />
                      <div className="detail">
                        <span className="number-or-date">{expiredDate}</span>
                        <span className="description">{I18n.t('expiry_date')}</span>
                      </div>
                    </div>
                    <div className="exist-sessions col-lg-6 col-md-6 col-sm-6 mb-6">
                      <img src={startDateImage} alt="upgradePackage" />
                      <div className="detail">
                        <span className="number-or-date">{startDate}</span>
                        <span className="description">{I18n.t('start_date')}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="info-package col-lg-12 col-md-12 col-sm-12 mb-12">
                <p className="title"> {I18n.t('transaction_history')} </p>
                <div className="info">
                  <div className="row history">
                    <div className="col-lg-2 col-md-2 col-sm-2 mb-2">
                      <span>{I18n.t('registration_period')}</span>
                    </div>
                    <div className="col-lg-8 col-md-8 col-sm-8 mb-8">
                      <span>{I18n.t('connection_sessions')}</span>
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-2 mb-2">
                      <span>{I18n.t('dashboard_filter_status')}</span>
                    </div>
                  </div>

                  {
                    historyUseSessions.map((item, index) => (
                      <div key={index} className="row history-detail">
                        <div className="col-lg-2 col-md-2 col-sm-2 mb-2 text-center">
                          <span>{item.time}</span>
                        </div>
                        <div className="col-lg-8 col-md-8 col-sm-8 mb-8">
                          <Link className="session" to={`/session/${item.sessionId}`}><span>{item.title}</span></Link>
                          <span className="time-session">{item.startTime} - {item.endTime} {item.endDate}</span>
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-2 mb-2 text-center">
                          <span>{item.status}</span>
                        </div>
                      </div>
                    ))}
                </div>
              </div>

              <div className="info-package col-lg-12 col-md-12 col-sm-12 mb-12">
                <p className="title"> {I18n.t('purchase_history')} </p>

                <div className="info">
                  <div className="row history">
                    <div className="col-lg-3 col-md-3 col-sm-3 mb-3">
                      <span>{I18n.t('purchase_time')}</span>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-3 mb-3">
                      <span>{I18n.t('purchased_package')}</span>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-3 mb-3">
                      <span>{I18n.t('amount')}</span>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-3 mb-3">
                      <span>{I18n.t('actual_payment')}</span>
                    </div>
                  </div>

                  {
                    historyTransactions.map((item, index) => (
                      <div key={index} className="row history-detail transaction-detail">
                        <div className="col-lg-3 col-md-3 col-sm-3 mb-3">
                          <span>{item.time}</span>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 mb-3 ">
                          <span>{item.package}</span>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 mb-3">
                          <span>{item.rawPrice} USD</span>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 mb-3">
                          <span>
                            {item.amount} {item.currency}
                            {
                              !!item.percent && (<span> (-{item.percent} %)</span>)
                            }
                          </span>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </main>
        {footer}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { mvp, user } = state;
  return {
    user
  }
};

const mapDispatchToProps = {
  getHistoryUseSessions,
  getHistoryTransactions,
  fetchUserMvp
}
export default connect(mapStateToProps, mapDispatchToProps)(MyPackage);
